import classnames from 'classnames';
import type { HairColorSwatch } from '../../hair-color-palette';
import styles from './HairColorPicker.module.scss';

interface HairColorPickerProps {
    swatches: readonly HairColorSwatch[];
    selectedId: string;
    onSelect: (swatchId: string) => void;
    isDisabled?: boolean;
}

/**
 * Hair color selector: a grid of round color swatches. No existing
 * swatch/color-picker component exists in `@sorrem/ui` to reuse, so this is
 * a small bespoke control scoped to this feature rather than a native
 * `<input type="color">` (which wouldn't match the curated-palette design
 * or the ornate visual language used elsewhere in character creation).
 */
export function HairColorPicker({ swatches, selectedId, onSelect, isDisabled = false }: HairColorPickerProps): JSX.Element {
    return (
        <div className={styles.swatches}>
            {swatches.map((swatch) => (
                <button
                    key={swatch.id}
                    type="button"
                    className={classnames(styles.swatch, swatch.id === selectedId && styles.selected)}
                    style={{ backgroundColor: swatch.hex }}
                    disabled={isDisabled}
                    onClick={() => onSelect(swatch.id)}
                    title={swatch.label}
                    aria-label={swatch.label}
                    aria-pressed={swatch.id === selectedId}
                />
            ))}
        </div>
    );
}
